import { useState, useEffect } from 'react';
import type { ReactElement } from 'react';

import { post } from 'utils/network';
import { ApiRoute } from 'config';

import { useUpcomingMenu } from 'contexts/UpcomingMenu';
import SkipMenuSurvey from 'models/SkipMenuSurvey';

import Button from 'react-bootstrap/Button';
import RadioButton from 'components/shared/RadioButton';
import Modal from 'components/shared/Modal';
import OutOfTownModal from './OutOfTownModal';

type Props = {
  show: boolean;
  onClose: () => void;
};

function SkipModal({ show, onClose }: Props): ReactElement {
  const { upcomingMenu } = useUpcomingMenu();
  const { menu_id: menuId } = upcomingMenu;
  const { type: planType } = upcomingMenu.plan;
  const surveyOptions = SkipMenuSurvey.getOptions(planType);
  const [options, setOptions] = useState(surveyOptions);
  const [selectedOption, setSelectedOption] = useState(null);
  const [otherValue, setOtherValue] = useState('');
  const [showOutOfTown, setShowOutOfTown] = useState(false);

  const onSelectionChange = (e) => setSelectedOption(e.target.id);
  const onOtherValueChange = (e) => setOtherValue(e.target.value);

  useEffect(() => {
    if (show) {
      setOptions(SkipMenuSurvey.getOptions(planType));
    } else {
      setSelectedOption(null);
      setOtherValue('');
    }
  }, [show, planType]);

  const onSubmit = () => {
    post(ApiRoute.SKIP_MENU_SURVEY, {
      menu_id: menuId,
      skip_menu_survey: {
        // @ts-expect-error TODO: fix null safety
        reason: options.find((opt) => opt.id === selectedOption).label,
        other_reason: selectedOption === 'other' ? otherValue : undefined,
        survey_type: 'order',
      },
    });

    onClose();

    // Re-enable it later for adding alternative option on skip rebuttal
    // for flex user base. Related card: TPC-7759. Remove this and the
    // SaveMoneyModal component if that card gets closed.

    // if (flexBoxVariant !== 0 && selectedOption === 'save_money') {
    //   setShowSaveMoney(true);
    // }

    if (selectedOption === 'traveling') {
      setShowOutOfTown(true);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onClose={onClose}
        className="c-modal-skip-menu-survey"
        header={<Modal.Header>Tell us more</Modal.Header>}
        body={(
          <form onSubmit={(e) => e.preventDefault()}>
            <fieldset className="c-form-group">
              <legend>
                Why did you choose to skip your Purple Carrot delivery?&nbsp;
                <sup>*</sup>
              </legend>
              {options.map((option) => (
                <RadioButton
                  key={option.id}
                  id={option.id}
                  label={option.label}
                  name="reason"
                  onChange={onSelectionChange}
                />
              ))}
            </fieldset>
            <div className="c-form-group string">
              {selectedOption === 'other' && (
                <input
                  id="other_reason"
                  placeholder="Please specify"
                  type="text"
                  value={otherValue}
                  onChange={onOtherValueChange}
                />
              )}
            </div>
          </form>
        )}
        footer={(
          <Button
            className="c-button c-button--primary"
            onClick={onSubmit}
            disabled={selectedOption === null
              || (selectedOption === 'other'
              && otherValue === '')}
          >
            Submit
          </Button>
        )}
      />
      <OutOfTownModal
        show={showOutOfTown}
        onClose={() => setShowOutOfTown(false)}
      />
    </>
  );
}

export default SkipModal;
